export default {
  "home": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Olá!✨"])},
    "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Como podemos ajudá-lo hoje? Estamos aqui para você, então vamos começar uma conversa!"])}
  },
  "conversation": {
    "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conversas atuais"])},
    "last_message_empty_caption": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nova conversa..."])},
    "welcome_text": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Olá! Bem-vindo a ", _interpolate(_named("messengerName")), "."])},
    "enter_message_info": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Por favor, digite sua pergunta abaixo para que possamos respondê-la rapidamente."])},
    "compose": {
      "input_placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Escreva uma mensagem..."])}
    },
    "survey": {
      "post": {
        "body": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adoraríamos saber o que você achou desta conversa:"])},
        "thank_you_msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Obrigado por seu feedback! Isso nos ajudará a melhorar nosso serviço para você e para os outros."])}
      }
    },
    "status": {
      "sending": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enviando..."])},
      "sent": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enviado"])},
      "conversation_is_closed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A conversa está encerrada"])}
    },
    "errors": {
      "404": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Não foi possível carregar a conversa!"])}
    }
  },
  "archived_conversations": {
    "header": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Conversas arquivadas (", _interpolate(_named("count")), ")"])}
  },
  "search": {
    "input_placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pesquisar artigos de ajuda"])},
    "no_results": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Nenhum resultado para \"", _interpolate(_named("query")), "\""])},
    "no_results_hint": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Por favor, tente uma palavra-chave diferente"])}
  },
  "channels": {
    "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Como você gostaria de entrar em contato hoje?"])},
    "whatsapp": {
      "card_header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enviar uma mensagem do WhatsApp"])},
      "qr_code_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Digitalize com seu aplicativo de câmera ou clique no código QR para iniciar uma conversa."])},
      "button_text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abrir WhatsApp"])},
      "number_undefined_error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["O número é indefinido."])},
      "initial_text_msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Olá, equipe! Eu queria saber..."])}
    }
  },
  "agents": {
    "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Atividade da equipe de suporte"])},
    "availability": {
      "online": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["   Nossa equipe está online"])},
      "offline": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["🔴 Nossa equipe está com algum tempo livre no momento 😴, mas deixe sua mensagem e entraremos em contato o mais rápido possível!"])}
    },
    "status": {
      "online": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Online"])},
      "offline": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Offline"])},
      "away": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fora"])}
    },
    "is_typing": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("agentName")), " está digitando..."])}
  },
  "forms": {
    "fields": {
      "_CONTACT_NAME": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nome"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "_CONTACT_EMAIL": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["(nome", "@", "empresa.com)"])}
      },
      "_CONTACT_PHONE": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Telefone"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ou seja, 351492160200..."])}
      },
      "_SUBJECT": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Assunto"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "_INITIAL_MESSAGE": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pergunta"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "_MESSAGE": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mensagem"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      }
    },
    "types": {
      "PRE_CHAT": {
        "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Preencha o formulário abaixo, para que possamos conhecê-lo 😄"])},
        "submit-btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Envie sua mensagem"])},
        "default-success-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Obrigado por deixar sua pergunta. Vamos configurar você com um dos membros da nossa equipe!"])},
        "default-error-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Opa, a conversa não pôde ser iniciada. Você pode tentar novamente?"])}
      },
      "CONTACT_DETAILS": {
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Preencha o formulário abaixo, para que possamos manter contato"])},
        "submit-btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enviar"])},
        "dismiss-btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Agora não"])},
        "default-success-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Obrigado por fornecer o seu endereço de e-mail."])},
        "default-error-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Opa, o formulário não pôde ser enviado"])}
      },
      "EMAIL": {
        "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Envie-nos uma linha"])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Preencha o formulário abaixo para entrar em contato com nossa equipe de suporte ao cliente"])},
        "submit-btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Envie sua mensagem"])},
        "default-success-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["O formulário de email foi enviado!"])},
        "default-error-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Opa, o e-mail não pôde ser entregue. Por favor, tente novamente."])}
      },
      "WHATSAPP_CONTACT": {
        "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Iniciar uma conversa no WhatsApp"])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Apresente-se e faça sua pergunta para que possamos ajudá-lo imediatamente."])},
        "submit-btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Envie sua mensagem"])},
        "default-success-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["O formulário de contato do WhatsApp foi enviado!"])},
        "default-error-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Opa, o formulário de contato do WhatsApp não pôde ser enviado. Você pode tentar novamente?"])}
      }
    }
  },
  "mailform": {
    "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Formulário de e-mail"])},
    "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Preencha o formulário abaixo para entrar em contato com nossa equipe de suporte ao cliente"])},
    "fields": {
      "NAME": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nome"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "SUBJECT": {
        "etiqueta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Assunto"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "QUESTION": {
        "etiqueta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pergunta"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "EMAIL": {
        "etiqueta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mail"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "UPLOAD": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "add_btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Juntar anexo"])}
      },
      "TOPIC": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tema"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Selecionar..."])}
      }
    },
    "notifications": {
      "success": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["O formulário de email foi enviado!"])},
      "errors": {
        "default": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Infelizmente o formulário não pode ser enviado. Você pode tentar novamente?"])}
      }
    },
    "submit_btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enviar mensagem"])}
  },
  "common": {
    "buttons": {
      "start_new_conversation": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vamos iniciar uma conversa"])},
      "show_archived_conversations": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Mostrar conversas arquivadas (", _interpolate(_named("count")), ")"])},
      "go_to_mailform": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enviar um e-mail em vez disso"])},
      "go_back": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voltar"])}
    },
    "page_title": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["💬 Nova mensagem \"", _interpolate(_named("message")), "\""])},
    "toast": {
      "generic_error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Opa, algo deu errado!"])},
      "message_sent_error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ocorreu um erro ao enviar a mensagem"])},
      "giphy_no_results": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nenhuma imagem do Giphy foi encontrada."])}
    },
    "errors": {
      "upload_too_large": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["O tamanho do arquivo não pode exceder 5 MB"])},
      "upload_file_type_disallowed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Este tipo de arquivo não é permitido"])}
    }
  },
  "gdpr": {
    "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Consentimento de cookies GDPR"])},
    "body": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Olá! Gostaríamos muito de falar com você. No entanto, de acordo com o Regulamento Geral de Proteção de Dados da UE, precisamos primeiro de sua aprovação para o uso de informações pessoais (por exemplo, seu nome e endereço de e-mail). Você concorda se :<br><br>1) Armazenaremos suas informações pessoais para que possamos retomar a conversa se conversarmos mais tarde;<br><br>2) Podemos enviar e-mails para acompanhar nossa conversa aqui; <br><br>3) Podemos enviar e-mails sobre nossos próximos serviços e promoções.<br>"])},
    "disapprove_body": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tudo bem. Você pode ver os termos e a política a qualquer momento e consentir em continuar"])},
    "yes": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sim, sem problemas"])},
    "no": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Não, hoje não"])}
  },
  "powered_by": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Powered by Grasp"])}
}